module.exports = __webpack_public_path__ + "img/skinny-mashed-potatoes.fc474e93.jpg";